/**
 * Category Module Initializer
 * Sets up all category-related functionality with ES6 modules
 */

import { AbortControllerManager } from '/modules/ui/abort-controller-manager.js';
import { APIClient } from '/modules/services/api-client.js';
import { CategoryController } from '/modules/features/category/category-controller.js';
import { CategoryValidator } from '/modules/features/category/category-validator.js';

// Configuration
const config = {
    emailSelector: 'input[type=email][data-email]'
};

// Initialize core services
const abortManager = new AbortControllerManager();
const apiClient = new APIClient(abortManager);

// Initialize feature controllers
const categoryController = new CategoryController(apiClient, config);
const categoryValidator = new CategoryValidator(config);

// Export instances for use in other modules if needed
export {
    abortManager,
    apiClient,
    categoryController,
    categoryValidator,
    config
};

// Create global wrapper functions for backward compatibility
// These allow onclick handlers and legacy code to work seamlessly
window.setCategory = function(code, dontUpdateCategories, dontUpdateSubcategories, callback) {
    return categoryController.setCategory(
        code, 
        dontUpdateCategories || false, 
        dontUpdateSubcategories || false, 
        callback || null
    );
};

window.setEmail = function(email) {
    return categoryController.setEmail(email);
};

window.saveTabCategory = function() {
    return categoryController.save();
};

// Initialize on DOM ready
$(document).ready(() => {
    console.log('🚀 Category module initialized');
    
    // Bind save event to tab collapse
    $('#tabCategory').on('hidden.bs.collapse', () => {
        window.saveTabCategory();
    });
    
    // Initialize validator
    categoryValidator.init();
    
    console.log('✅ Category module ready');
    
    // Notify module loader via event (auto-registration)
    window.dispatchEvent(new CustomEvent('module-loaded', { 
        detail: { moduleName: 'category-module' }
    }));
});

// Expose module for debugging in console
if (typeof window !== 'undefined') {
    window.CategoryModule = {
        controller: categoryController,
        validator: categoryValidator,
        apiClient,
        abortManager,
        config
    };
    console.log('🔧 CategoryModule available in window for debugging');
}
